export default __webpack_public_path__ + "static/media/announce.ffa786d4.png";